import '.e{display:flex;}.ssr-plugin'
import '.g{gap:8px;}.ssr-plugin'
import '.a9{height:4px;}.ssr-plugin'
import '.h{flex:1;}.ssr-plugin'
import '.ea{border-radius:8px;}.ssr-plugin'
import { styled, Style } from 'inlines'
import { colors } from '../utils/colors.js'
import { transparentColor } from '../utils/transparentcolor.js'

type StepperProps = {
  steps: number
  currentStep: number
  style?: Style
}

export const Stepper = ({ steps, currentStep, style }: StepperProps) => {
  return (
    <styled.div className="e g a9"
      style={{
        ...style,
      }}
    >
      {Array.from({ length: steps }).map((_, index) => (
        <div className="h a9 ea"
          key={index}
          style={{
            backgroundColor:
              index < currentStep ? colors.white : `${transparentColor(colors.white, 0.15)}`,
          }}
        />
      ))}
    </styled.div>
  )
}
